// @flow

import React from 'react';
import uuid from 'uuid';
import { Table, Button, Divider, Form } from 'semantic-ui-react';
import type { PluginProps } from '../QuestionContent';

type Choice = {
  id: string,
  value: string,
  label: ?string,
};

const createDefaultChoice = () => ({
  id: uuid(),
  value: '',
});

const updateChoices = (
  choices: Array<Choice>,
  choice: Choice
): Array<Choice> => {
  return choices.map(item => {
    if (item.id !== choice.id) {
      return item;
    } else {
      return {
        ...item,
        ...choice,
      };
    }
  });
};

const isContentValid = content => {
  return (
    content.choices == null ||
    content.choices.every(choice => choice.value.length > 0)
  );
};

const DropdownContent = ({
  content,
  showValidationErrors,
  onChange,
}: PluginProps) => {
  const choices = content.choices || [];

  const change = content =>
    onChange({
      ...content,
      isValid: isContentValid(content),
      hasChanged: true,
    });

  const addChoice = () =>
    change({
      ...content,
      choices: [...choices, createDefaultChoice()],
    });

  const updateChoice = (choice: Choice) =>
    change({
      ...content,
      choices: updateChoices(choices, choice),
    });

  const deleteChoice = (choice: Choice) =>
    change({
      ...content,
      choices: choices.filter(c => c.id !== choice.id),
    });

  return (
    <div>
      <Divider />
      <DropdownChoices
        choices={choices}
        showValidationErrors={showValidationErrors}
        onChangeChoice={updateChoice}
        onDeleteChoice={deleteChoice}
      />
      <Button
        onClick={addChoice}
        type="button"
        icon="plus"
        labelPosition="left"
        content="Ajouter une réponse"
        size="small"
      />
      <Divider />
    </div>
  );
};

type ChoicesProps = {
  choices: Array<Choice>,
  onChangeChoice: (choice: Choice) => void,
  onDeleteChoice: (choice: Choice) => void,
};

const DropdownChoices = ({
  choices,
  showValidationErrors,
  onChangeChoice,
  onDeleteChoice,
}: ChoicesProps) => {
  if (choices.length > 0) {
    return (
      <Table basic="very" celled>
        <Table.Body>
          {choices.map((choice, index) => (
            <DropdownChoice
              key={choice.id}
              choice={choice}
              showValidationErrors={showValidationErrors}
              index={index}
              onChange={onChangeChoice}
              onDelete={onDeleteChoice}
            />
          ))}
        </Table.Body>
      </Table>
    );
  } else {
    return null;
  }
};

const styles = {
  buttons: {
    delete: {
      marginTop: '22px',
    },
  },
};

const DropdownChoice = ({
  choice,
  showValidationErrors,
  index,
  onChange,
  onDelete,
}) => {
  const changeValue = event =>
    onChange({
      ...choice,
      value: event.target.value,
    });

  const deleteChoice = () => onDelete(choice);

  return (
    <Table.Row>
      <Table.Cell width={1} textAlign="center" verticalAlign="middle">
        {index + 1}.
      </Table.Cell>
      <Table.Cell width={14}>
        <Form.Field
          required
          error={showValidationErrors && choice.value.length === 0}
        >
          <label>Libellé de la réponse</label>
          <input
            type="text"
            value={choice.value}
            placeholder="Saisissez le libellé de la réponse"
            onChange={changeValue}
          />
        </Form.Field>
      </Table.Cell>
      <Table.Cell width={1} textAlign="center" verticalAlign="middle">
        <Button
          type="button"
          size="small"
          icon="close"
          style={styles.buttons.delete}
          onClick={deleteChoice}
        />
      </Table.Cell>
    </Table.Row>
  );
};

export default DropdownContent;



// WEBPACK FOOTER //
// ./src/modules/survey/components/questions/contents/DropdownContent.js